import { useEffect } from 'react';
import { useFilter } from './FilterContext';
import useUrlFiltersHelper from './useUrlFiltersHelper';

const useUrlFilters = async () => {
  const { getFilters, setFilters } = useFilter();
  const { getEnabledFilters, getSelectedFilters } = useUrlFiltersHelper();

  const enabledFilters = getEnabledFilters();
  const selectedFilters = getSelectedFilters();
  const urlFiltersString = enabledFilters.toString() + selectedFilters.toString();

  const filters = getFilters();

  const isFiltersLoaded = filters.length > 0;

  useEffect(() => {
    if (!isFiltersLoaded) return;

    setFilters(
      filters.map(filter => {
        // from url to context state
        const isEnabledViaUrl = enabledFilters.filter(id => id === filter._id).length > 0;
        const isSelectedViaUrl = selectedFilters.filter(id => id === filter._id).length > 0;
        if (isEnabledViaUrl) {
          return { ...filter, selected: true, enabled: true };
        }
        if (isSelectedViaUrl) {
          return { ...filter, selected: true, enabled: false };
        }
        return { ...filter, selected: false, enabled: false };
      })
    );
  }, [isFiltersLoaded, urlFiltersString]);
};

export default useUrlFilters;
